import { SaveOutlined } from '@ant-design/icons';
import ConfirmationModal from '../confirmation-modal/ConfirmationModal';
import { Typography } from 'antd';

type Props = {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const UnsavedChangesWarningModal = ({ open, onCancel, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            width={540}
            open={open}
            type="error"
            title="Unsaved Changes"
            icon={<SaveOutlined />}
            cancelButtonText="Go Back"
            confirmButtonText="Leave Without Saving"
            content={
                <>
                    <Typography.Text>
                        You have unsaved changes. Are you sure you want to leave this page?
                    </Typography.Text>
                </>
            }
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
};

export default UnsavedChangesWarningModal;
